import React from 'react'
import { connect } from "react-redux";
import LandingPage from './LandingPage'
import LandingPageRight from './LandingPageRight'



function index({auth}) {
const bookingFlag=auth?.bookingStatus==='BOOKABLE'
  return (
    <>
    {bookingFlag ? <LandingPage/> :  <LandingPageRight/> }
    </>
  )
}
const mapStateToProps = (state) => ({
  auth: state.auth,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(index);